export const GET_LANGUAGES_SUCCESS="code/GET_LANGUAGES_SUCCESS";
export const GET_LANGUAGES_FAILURE="code/GET_LANGUAGES_SUCCESS"
export const GET_CATEGORY_SUCCESS="code/GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_FAILURE="code/GET_CATEGORY_FAILURE"
export const GET_LEVEL_CONTENT_SUCCESS="code/GET_LEVEL_CONTENT_SUCCESS";
export const GET_LEVEL_CONTENT_FAILURE="code/GET_LEVEL_CONTENT_FAILURE"
export const GET_SUB_LEVEL_CONTENT_SUCCESS="code/GET_SUB_LEVEL_CONTENT_SUCCESS";
export const GET_SUB_LEVEL_CONTENT_FAILURE="code/GET_SUB_LEVEL_CONTENT_FAILURE"
export const SUGGESTION_SUCCESS="code/SUGGESTION_SUCCESS";
export const SUGGESTION_FAILURE="code/SUGGESTION_FAILURE";
export const CODING_STATS_SUCCESS="code/CODING_STATS_SUCCESS";
export const CODING_STATS_FAILURE="code/CODING_STATS_FAILURE";